var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.31871 3.68643C2.44114 3.42042 2.70718 3.25 3.00001 3.25H21C21.2928 3.25 21.5589 3.42042 21.6813 3.68643C21.8037 3.95243 21.7602 4.26537 21.5697 4.4878L14.55 12.6861V21C14.55 21.2593 14.4161 21.5002 14.1959 21.637C13.9757 21.7739 13.7004 21.7873 13.4679 21.6725L9.86793 19.8947C9.61201 19.7683 9.45001 19.5076 9.45001 19.2222V12.6861L2.43031 4.4878C2.23986 4.26537 2.19628 3.95243 2.31871 3.68643ZM4.62955 4.75L10.7697 11.9211C10.8861 12.057 10.95 12.23 10.95 12.4089V18.7561L13.05 19.7932V12.4089C13.05 12.23 13.114 12.057 13.2303 11.9211L19.3705 4.75H4.62955Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOff);
export default __webpack_public_path__ + "static/media/Filter-off.ea5a2bcc49ac00d06158eabf7b9f821f.svg";
export { ForwardRef as ReactComponent };